export var AuthenticationMethods;
(function (AuthenticationMethods) {
    AuthenticationMethods["Local"] = "local";
    AuthenticationMethods["Totp"] = "totp";
    AuthenticationMethods["Saml"] = "saml";
})(AuthenticationMethods || (AuthenticationMethods = {}));
//# sourceMappingURL=authentication-methods.js.map